<template>
  <b-col md="12">
    <section class="info">
      <p class="info__title">Informazioni importanti</p>
      <div class="info__wrap">
        <span v-html="confirm.bookingVoucher.property.important_information.replaceAll('.', '.<br>')" />
      </div>
      <policies :details="confirm.bookingVoucher.property" />
    </section>
  </b-col>
</template>

<script>
import Policies from "@bookingv3/components/blocks/detail/policies"

export default {
  name: 'info',

  components: {
    'policies': Policies,
  },

  props: {
    confirm: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .info {
    margin-top: $grid-gutter-width * 2;

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 20px;
    }

    &__wrap {
      padding: 15px 20px;
      background-color: $white;
      border-radius: 10px;
    }

    @media print {
      display: none;
    }

    ::v-deep {
      .policies  {
        margin: 0;
        border: none;

        &__title {
          display: none;
        }
      }
    }

  }

</style>